import { API_END_POINTS } from '../constants/apiEndPointConstants'
import axiosInstance from './axiosInstance'

export const authenticate = async (email, password) => {
  const URL = API_END_POINTS.authenticate
  try {
    const response = await axiosInstance.post(URL, { email, password })
    return response
  } catch (error) {
    return error?.response
  }
}

export const getQrUrl = async (email) => {
  const URL = `${API_END_POINTS.qrCode}?email=${email}`
  try {
    const response = await axiosInstance.get(URL)
    return response?.data
  } catch (err) {
    return err.response
  }
}

export const getOtpAutheticate = async (code, email, preAuthToken) => {
  const URL = API_END_POINTS.gAuthenticate

  // preAuthToken is a short-lived step-up credential returned by /authenticate.
  // It is held only in React state (never written to any storage) and is sent
  // here as the "first factor" proof during the OTP/2FA verification step.
  try {
    const response = await axiosInstance.post(
      URL,
      { code, email },
      {
        headers: {
          Authorization: `Bearer ${preAuthToken}`,
        },
      }
    )
    return response
  } catch (err) {
    throw err
  }
}

export const logoutService = async () => {
  const URL = API_END_POINTS.logout
  const response = await axiosInstance.post(URL)
  return response
}